export function getStudentDisplayName(student) {
  const firstName = (student?.first_name || '').trim();
  const lastName = (student?.last_name || '').trim();
  const joined = [firstName, lastName].filter(Boolean).join(' ').trim();
  if (joined) return joined;

  const displayName = (student?.display_name || '').trim();
  if (displayName) return displayName;

  const grade = (student?.grade_year_level || '').trim();
  if (grade) return `(No name) ${grade}`;

  const uuid = student?.uuid || '';
  return `(No name) ${uuid ? `ID: ${uuid.substring(0, 8)}` : 'Student'}`;
}

